angular.module('bookAndPay').directive('appHeader', function() {
  return {
    restrict: 'EA',
    template: require('templates/book_and_pay/header.html.slim'),
    controller: ["$scope", "DataService", function($scope, DataService) {
      return $scope.data = DataService;
    }]
  };
});
